export const weatherReportColumns = (renderStat) => [
  {
    title: 'Temperature',
    children: [
      {
        title: 'Low',
        dataIndex: 'temperatureLow',
        key: 'temperatureLow',
        render: renderStat,
      },
      {
        title: 'High',
        dataIndex: 'temperatureHigh',
        key: 'temperatureHigh',
        render: renderStat,
      },
      {
        title: 'Avg',
        dataIndex: 'temperatureAvg',
        key: 'temperatureAvg',
        render: renderStat,
      },
    ],
  },
  {
    title: 'Precipitation Since',
    children: [
      {
        title: 'Midnight',
        dataIndex: 'precipitation1',
        key: 'precipitation1',
        render: renderStat,
      },
      {
        title: '2 days',
        dataIndex: 'precipitation2',
        key: 'precipitation2',
        render: renderStat,
      },
      {
        title: '3 days',
        dataIndex: 'precipitation3',
        key: 'precipitation3',
        render: renderStat,
      },
    ],
  },
  {
    title: 'Humidity',
    children: [
      {
        title: 'Low',
        dataIndex: 'humidityLow',
        key: 'humidityLow',
        render: renderStat,
      },
      {
        title: 'Avg',
        dataIndex: 'humidityAvg',
        key: 'humidityAvg',
        render: renderStat,
      },
      {
        title: 'High',
        dataIndex: 'humidityHigh',
        key: 'humidityHigh',
        render: renderStat,
      },
    ],
  },
  {
    title: 'Windspeed',
    children: [
      {
        title: 'Avg',
        dataIndex: 'windspeedAvg',
        key: 'windspeedAvg',
        render: renderStat,
      },
      {
        title: 'High',
        dataIndex: 'windspeedHigh',
        key: 'windspeedHigh',
        render: renderStat,
      },
      {
        title: 'Gust',
        dataIndex: 'windspeedGust',
        key: 'windspeedGust',
        render: renderStat,
      },
    ],
  },
];

const formatTimeForDisplay = (hour) => {
  if (hour === 0) return '12:00am';
  if (hour < 12) return `${hour}:00am`;
  if (hour === 12) return '12:00pm';
  return `${hour - 12}:00pm`;
};

const formatTimeForDataIndex = (hour) => {
  if (hour === 0) return '12am';
  if (hour < 12) return `${hour}am`;
  if (hour === 12) return '12pm';
  return `${hour - 12}pm`;
};

export const generateDailySnapshotColumns = (renderHourlyConditions, startHour = 6, endHour = 21) => {
  const columns = [];
  const endCondition = (endHour + 3) % 24;

  for (let hour = startHour; hour !== endCondition; hour = (hour + 3) % 24) {
    columns.push({
      title: formatTimeForDisplay(hour),
      dataIndex: formatTimeForDataIndex(hour),
      key: formatTimeForDataIndex(hour),
      render: renderHourlyConditions,
    });
  }

  return columns;
};
